import "./shared"

// 追加で読み込むアセット
import "../stylesheets/influencer"